import React from "react";
import styled from "styled-components";
import { Twitter, Bsky } from "../Icons/Icons";
import { FOOTER_HEIGHT } from "../../constants";
import ZuckPlus from "../ZuckPlus/ZuckPlus";
const Wrapper = styled.footer`
  height: ${FOOTER_HEIGHT}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-family: monospace;
  align-items: flex-end;
  font-size: 1.25rem;
  @media (max-width: 600px) {
    font-size: 1rem;
  }
  gap: 16px;
`;

const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  color: var(--color-indigo-900);
  cursor: pointer;

  transition: color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      color: var(--color-indigo-500);
    }
  }
`;

const Link = styled.a`
  color: inherit;
  display: inline;
  transition: color 0.1s ease-in-out;

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
      color: var(--color-indigo-500);
    }
  }
`;

const Socials = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

function Footer({ hasPurchasedZuckPlus, setHasPurchasedZuckPlus }) {
  return (
    <Wrapper>
      <Socials>
        <SocialLink href="https://x.com/itseieio">
          <Twitter />
        </SocialLink>
        <SocialLink href="https://bsky.app/profile/itseieio.bsky.social">
          <Bsky />
        </SocialLink>
      </Socials>
      <p>
        a website by{" "}
        <Link href="https://eieio.games/blog/smile-like-zuck/">eieio</Link>
      </p>
    </Wrapper>
  );
}

export default Footer;
